import { useFrontendTool } from "@copilotkit/react-core"
import { useHistory } from "react-router"
import farmSo from "stores/farm"
import locationSo from "stores/route/location"
import querySo from "stores/route/query"
import { getUrlByPageId } from "stores/route/utils/pagesId"
import { PAGE_ID, URL_PAR } from "stores/route/utils/types"
import statsSo from "stores/stats"
import { dateToUrl, haveValueDateRange, humanDateRange, stringToDateRange } from "utils"
import { waitNavigate } from "./utils"
import { TOOLS } from "./utils/types"
import { LastDateRange } from "stores/planner/utils/fetch"



/**
 * Prmette di utilizzare una PIVOTGRID
 */
export function usePlanner() {

	const history = useHistory()

	useFrontendTool({
		name: "show_gantt",
		description: `Visualizza un GANTT (anche detto PLANNER). Nelle ordinate (Y) i LAYERs di tutte le GROWUNITs e nelle ascisse (X) le date giornaliere della FARM selezionata.
Sulla griglia vengono visualizzate le coltivazioni programmate e fatte (CYCLEs) con i relativi CROP LOTs.
C'e' il pannello STATISTICS che visualizza dei GRAPHS per CROP sull utilizzo dei LAYERS e resa (yield) reale vs prevista.
## A COSA SERVE
- Visualizzare l'utilizzo nel tempo, individuare spazi vuoti e sfruttamento dei LAYERS di una FARM.
- Il piano di coltivazione generale
- Avere i GRAPHS STATISTICS dell'utilizzo dei LAYERS e della produzione.
## A COSA NON SERVE
- Per visualizzare molti dati di produzione e filtrare per trovare un valore in praticolare usa ${TOOLS.SHOW_PIVOT_GRID}.
`,
		parameters: [
			{
				name: "date_start_selected",
				description: "La data (yyyy-mm-dd) inizio delle STATISTICS. Se non presente prende le disponibili.",
				type: "string",
				required: false,
			},
			{
				name: "date_end_selected",
				description: "La data (yyyy-mm-dd) fine delle STATISTICS. Se non presente prende le disponibili.",
				type: "string",
				required: false,
			},
		],
		handler: async ({ date_start_selected, date_end_selected }) => {

			if (!farmSo.state.select) return {
				success: false,
				error: `Devi selezionare una FARM prima. Usa il tool ${TOOLS.NAVIGATE_IN_FARM_SECTION} per selezionare una FARM e poi ripeti questa azione.`
			}

			if (locationSo.state.currentPage != PAGE_ID.FARM_PLANNER) {
				const url = getUrlByPageId(PAGE_ID.FARM_PLANNER, farmSo.state.select.id)
				await waitNavigate(url, history)
			}

			const range = stringToDateRange(date_start_selected, date_end_selected)
			const dateRangeLabel = humanDateRange(range) ?? humanDateRange(LastDateRange)

			if (!!date_start_selected && !!date_end_selected) {
				if (haveValueDateRange(range)) {
					querySo.setSearchUrl([URL_PAR.DATE_SEL, dateToUrl(range)])
				}
			}

			statsSo.setDrawerOpen(true)

			return {
				success: true,
				message: `Planner visualizzato con il range di date ${dateRangeLabel}.`
			}
		},
	})
}



